import { Action } from 'redux';
import { Availability } from 'types/Availability';

export const AVAILABILITY_RESET = 'availability/reset';
export const AVAILABILITY_FETCH_START = 'availability/fetch_start';
export const AVAILABILITY_FETCH_SUCCESS = 'availability/fetch_success';
export const AVAILABILITY_FETCH_FAILED = 'availability/fetch_failed';
export const AVAILABILITY_SAVE_START = 'availability/save_start';
export const AVAILABILITY_SAVE_SUCCESS = 'availability/save_success';
export const AVAILABILITY_GET_NEXT_DATE_START = 'availability/get_next_date_start';
export const AVAILABILITY_GET_NEXT_DATE_SUCCESS = 'availability/get_next_date_success';

export const AVAILABILITY_ERROR = 'availability/error';

interface AvailabilityResetAction extends Action<typeof AVAILABILITY_RESET> {}
interface AvailabilityFetchStartAction extends Action<typeof AVAILABILITY_FETCH_START> {}
interface AvailabilityFetchSuccessAction extends Action<typeof AVAILABILITY_FETCH_SUCCESS> {
    payload: {
        availableHours: Array<Availability>;
    };
}
interface AvailabilityGetNextDateStartAction
    extends Action<typeof AVAILABILITY_GET_NEXT_DATE_START> {}
interface AvailabilityGetNextDateSuccessAction
    extends Action<typeof AVAILABILITY_GET_NEXT_DATE_SUCCESS> {
    payload: {
        availableHours: Array<Availability>;
    };
}

interface AvailabilityErrorAction extends Action<typeof AVAILABILITY_ERROR> {}

export type AvailabilityAction =
    | AvailabilityResetAction
    | AvailabilityFetchStartAction
    | AvailabilityFetchSuccessAction
    | AvailabilityGetNextDateStartAction
    | AvailabilityGetNextDateSuccessAction
    | AvailabilityErrorAction;
